import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IStore } from 'reducers/index';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { bulkDownloadFile, resetEtsDownload } from 'actions/ets';
import API from 'constants/api';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { bulkDownload } from 'constants/validationMessages';
import { bulkDownloadfile } from 'utilities/download';



const SDiv = styled.div`
    margin-bottom: 15px;
`;

export interface IDownload extends IMapStateToProps, IDispatch, RouteComponentProps {
  catagory: string;
}

interface IMapStateToProps {
    bulkDownloadString: any;
    bulkDownloadStringExport: any;
    isFetchDataError: boolean;
    bulkDownloadFile: any;
    bulkDownloadfilename: string;
    isDownloadLoading: boolean;
}

interface IDispatch {
  getDownloadFile: (id: any) => Promise<void>;
  resetEtsDownload: () => void;
}

const _BulkDownload = (props: IDownload) =>{
  const [messages, setMessage] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [type, setType] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [isNetworkError, setIsNetworkError] = useState(false);
    
    const fetchFile = async () => {
      const dString = props.catagory === 'export' ? props.bulkDownloadStringExport : props.bulkDownloadString;
      if(props.bulkDownloadString || props.bulkDownloadStringExport) {
        await props.getDownloadFile(dString)
      }
    };
    useEffect(() => {
        if(props.bulkDownloadFile) {
          bulkDownloadfile(props.bulkDownloadFile, props.bulkDownloadfilename)
        }
        return () => {
          props.resetEtsDownload();
        };
    }, [props.bulkDownloadFile, props.bulkDownloadfilename]);


    useEffect(() => {
        setShowDialog(true)
        setIsDownloading(true)
        const requestUrl = `${API.ETS.DownloadStatus}/${props.catagory === 'export'  ? props.bulkDownloadStringExport : props.bulkDownloadString }`;
        const token = localStorage.getItem('accessToken');
        const eventSource = new EventSourcePolyfill(requestUrl, {
        headers: {
            ...API.HeadersFeatureToggle,
            'withCredentials': 'true',
            'Authorization' : `Bearer ${token}`,
          },
          heartbeatTimeout: 300000,
          withCredentials: true
        })

        eventSource.onopen = (event) => {
          setMessage('')
        }

        eventSource.onmessage = (event: any) => {
          setMessage(event.data)
          if(event.data === '"Ready For Download"') {
            setIsDownloading(false)
            setIsNetworkError(false)
            setType('success')
            setErrorMsg(bulkDownload.Success_Msg)
            if(eventSource){
              eventSource.close();
            }
          }
          if(event.data === '"Failed"') {
            setType('failed')
            setIsNetworkError(false)
            setErrorMsg(bulkDownload.Error_Msg)
            setIsDownloading(false)
            if(eventSource){
              eventSource.close();
            }
          }
        };
      
        eventSource.onerror = () => {
          setType('failed')
          setIsNetworkError(true)
          setErrorMsg(bulkDownload.Error_Msg)
          setIsDownloading(false)
          if(eventSource){
            eventSource.close();
          }
        }
        return () => {
          eventSource.close();
        };
    }, []);
    
  const link = <a onClick={() => { props.history.push(`/exception-management/charge-download/${props.catagory}`) }}><u>Charge Download Logs</u></a>

  const getMessageText = () => {
    return type === 'success' ? <div><i aria-hidden="true" className={'fas fa-check-circle fa-3x padding-right-medium'} />File created</div> :
     <div><i aria-hidden="true" className={'fa fa-times-circle fa-3x padding-right-medium'} />{isNetworkError ? 'Please check the charge download logs page' : 'File creation failed'}</div> ;
  }
   
    return (

    <div className={'grid-wrapper regular-body-text'}>
    <><div className="col-100">
        <div className={'download'}>
          <div>
            <p>Get Excel file with selected charges</p>
          </div>
        </div>
      </div><div className={'upload'}>
          <div className={isDownloading ? 'margin-top-xLarge' : 'hidden'}>
            <div>
            <span className="padding-right-medium">
              <i className="fas fa-solid fa-spin fa-spinner blue-status-color fa-lg" aria-hidden="true" /></span>
              <label>Creating file...</label> <br />
              <label>Current Status : { messages }</label>
            </div>
          </div>

            {!isDownloading && showDialog &&
                    <div className={'padding-top-xLarge'}>
                        <label className="padding-bottom-medium padding-top-large">{getMessageText()}</label>
                        {type === 'success' && <div className="button-group">
                            <button type="button" className="button-large button-blue" onClick={() => fetchFile()}>Download</button>
                        </div> }
                    </div>
                    
                }
              <div className={showDialog ? 'padding-top-large' : 'hidden'}>
                  {showDialog && type === 'failed' &&
                      <SDiv className={`message ${type}`}>
                          <i aria-hidden="true" className="fa fa-times-circle fa-3x" />
                              <span id="message_success">{errorMsg}</span>
                  </SDiv>}
              </div>

              <div className={showDialog ? 'padding-top-large' : 'hidden'}>
                  {showDialog && type === 'success' &&
                      <SDiv className={`message ${type}`}>
                          <i aria-hidden="true" className={'fas fa-check-circle fa-3x'} />
                              <span id="message_success">{errorMsg}</span>
                  </SDiv>}
              </div>
          <div className={showDialog && messages ? 'padding-top-medium' : 'margin-top-large'}>
            <SDiv className={`message info`}>
              <i aria-hidden="true" className={'fa fa-info-circle fa-3x'} />
              <span id="message_success">The progress and status of creating the file will be available in the {link} page within Exception Management</span>
            </SDiv>
          </div>
        </div></>
      </div>
      
    );
  }

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    bulkDownloadString: state.ets.bulkDownloadString,
    bulkDownloadStringExport: state.exportJob.bulkDownloadString,
    bulkDownloadFile: state.ets.bulkDownloadFile,
    bulkDownloadfilename: state.ets.bulkDownloadfilename,
    isFetchDataError: state.ets.isUploadDataError,
    isDownloadLoading: state.ets.isDownloadLoading
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IDispatch => ({
    getDownloadFile: (id: string) => dispatch(bulkDownloadFile(id)),
    resetEtsDownload: () => dispatch(resetEtsDownload())
});

const __SearchEts = connect<IMapStateToProps, IDispatch, {}, IStore>(mapStateToProps, mapDispatchToProps)(_BulkDownload);
export const BulkDownload = withRouter(__SearchEts);

